import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';

const AdminProfileMenu = () => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [superAdminUser, setSuperAdminUser] = useState(null); // Can be null or default
  const navigate = useNavigate();

  // Load super admin user data from localStorage
  useEffect(() => {
    try {
      const superAdminUserData = localStorage.getItem('superAdminUser');
      const role = localStorage.getItem('role');

      if (superAdminUserData && superAdminUserData !== 'undefined' && role === 'superadmin') {
        const parsedUser = JSON.parse(superAdminUserData);
        setSuperAdminUser(parsedUser);
      } else {
        // Default to a placeholder Super Admin if not logged in
        setSuperAdminUser({ username: 'Super Admin' }); // Default username
      }
    } catch (err) {
      console.error('Error loading super admin user data in ProfileMenu:', err);
      setSuperAdminUser({ username: 'Super Admin' }); // Fallback to default
    }
  }, []);

  const handleLogout = () => {
    try {
      localStorage.removeItem('superAdminToken');
      localStorage.removeItem('superAdminUser');
      localStorage.removeItem('role');
      navigate('/super-admin');
      setOpen(false);
      // Reset to default Super Admin after logout
      setSuperAdminUser({ username: 'Super Admin' });
    } catch (err) {
      setError('Failed to log out. Please try again.');
    }
  };

  const alertStyle = {
    backgroundColor: '#F3E8FF',
    color: '#6B21A8',
    padding: '8px',
    borderRadius: '8px',
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: "'Roboto', sans-serif",
    animation: 'slideInFromRight 0.5s ease-out',
    fontSize: '0.875rem',
  };

  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '0.875rem',
    cursor: 'pointer',
    color: '#6B21A8',
    fontFamily: "'Roboto', sans-serif",
  };

  // Always render the profile with default or logged-in data
  return (
    <div style={{ position: 'relative', fontFamily: "'Roboto', sans-serif" }}>
      <style>{`
        @keyframes slideInFromRight {
          0% {
            transform: translateX(100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>

      {error && (
        <div style={alertStyle}>
          <span>{error}</span>
          <button
            style={closeButtonStyle}
            onClick={() => setError('')}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}

      <div
        onClick={() => setOpen(!open)}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          padding: '0.3rem',
          borderRadius: '12px',
          backgroundColor: '#ffffff',
          color: '#1f2937',
        }}
      >
        <img
          src="/images/admin profile photo.jpg"
          alt="Super Admin Profile"
          style={{ borderRadius: '50%', marginRight: '8px', width: '40px', height: '40px' }}
        />
        <div>
          <div style={{ fontWeight: '600', fontSize: '1rem', fontFamily: "'Roboto', sans-serif" }}>
            {superAdminUser?.username || 'Super Admin'}
          </div>
          <div style={{ fontSize: '12px', color: '#6B7280', fontFamily: "'Roboto', sans-serif" }}>
            Super admin
          </div>
        </div>
      </div>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: '70px',
            right: 0,
            width: '220px',
            background: '#fff',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)',
            borderRadius: '16px',
            overflow: 'hidden',
            zIndex: 1000,
          }}
        >
          <div style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src="/images/admin profile photo.jpg"
                alt="Super Admin Profile"
                style={{ borderRadius: '50%', marginRight: '10px', width: '40px', height: '40px' }}
              />
              <div>
                <div style={{ fontWeight: '600', fontSize: '1rem', fontFamily: "'Roboto', sans-serif" }}>
                  {superAdminUser?.username || 'Super Admin'}
                </div>
                <div style={{ fontSize: '12px', color: '#6B7280', fontFamily: "'Roboto', sans-serif" }}>
                  Super Admin Panel
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: '10px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '0.5rem',
                borderRadius: '8px',
                transition: 'background-color 0.3s',
                fontFamily: "'Roboto', sans-serif",
              }}
              onClick={handleLogout}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f9fafb')}
              onMouseOut={(e) => (e.target.style.backgroundColor = 'transparent')}
            >
              <FaSignOutAlt style={{ marginRight: '8px', color: '#6B21A8' }} /> Log out
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminProfileMenu;